import { capitalize } from "./String"

export function toURL(str: string): URL | undefined {
  try {
    return new URL(str)
  } catch {
    return undefined
  }
}

export function addTrailingSlash(url: URL): URL {
  if (url.pathname.endsWith("/")) return url
  const newUrl = new URL(url)
  newUrl.pathname += "/"
  return newUrl
}

export function getUrlTitle(url: URL) {
  try {
    return (
      url.host
        .split(".")
        .slice(0, -1)
        .filter((str) => str !== "www")
        .map(capitalize)[0] ?? ""
    )
  } catch {
    return ""
  }
}

interface CreateRouteParamsType {
  params: Record<string, string | undefined>
}
/**
 * Returns an Object of route Parameters with entries of undefined values removed
 * @param params Object with entries of type Record<string, string | undefined>
 * @returns Object with undefined entries removed Record<string, string>
 */
export function createRouteParams(
  props: CreateRouteParamsType
): Record<string, string> {
  const { params } = props

  return Object.entries(params).reduce<Record<string, string>>(
    (acc, [key, value]) => {
      if (value !== undefined) {
        return { ...acc, [key]: value }
      }

      return acc
    },
    {}
  )
}
